<template>
  <div class="cs-row">
    <div class="puzzle-box">
      <div class="show-txt show-left">{{ $t("peopleBoardWhat") }}</div>
      <Row class="patentialRow" v-for="(item, index) in data" :key="index">
        <Col span="3">
          <span>{{ lang == "zh" ? item.scopeType : item.enScopeType }}</span>
        </Col>
        <Col span="4" v-for="num in legendData.length" :key="num + '-bg'">
          <div
            class="potentialBox"
            :style="{ background: getBackground(index, num) }"
          >
            <div v-if="item['peopleNameList' + num].length > 0">
              <Poptip
                v-model="item1.visible"
                popper-class="popClass"
                placement="right"
                width="300px"
                v-for="(item1, index1) in item['peopleNameList' + num]"
                :key="index1"
                transfer
                :disabled="item1.moreFlag == 1"
              >
                <div
                  v-if="item1.moreFlag == 1"
                  class="other-item"
                  style="margin: 2px"
                  @click="onShowMore(item, num)"
                  >{{ lang == "zh" ? item1.userName : item1.userEName }}</div
                >
                <div
                  v-if="item1.moreFlag != 1"
                  class="peo-item"
                  style="margin: 2px"
                  >{{ lang == "zh" ? item1.userName : item1.userEName }}</div
                >
                <div class="poptipContent" slot="content">
                  <div style="display: flex; align-items: center">
                    <h2 style="color: black">{{ item1.userName }}</h2>
                    <h2 style="color: #666666; margin-left: 15px">
                      {{ item1.userEName }}
                    </h2>
                    <span
                      style="margin-left: 15px"
                      v-if="item1.beT1Successor > 0"
                      ><Tag>T1继任</Tag></span
                    >
                  </div>
                  <div style="display: flex; flex-wrap: wrap">
                    <Form :label-width="120" label-position="left">
                      <Row>
                        <Col span="24">
                          <FormItem :label="$t('Talent Tag')"
                            ><!-- 人才标签 -->
                            <Tag
                              color="primary"
                              v-for="(el, index) in item1.abilityList"
                              :key="index"
                              >{{ el.ability }}</Tag
                            >
                          </FormItem>
                        </Col>
                        <Col span="24"
                          ><!-- 离职风险 -->
                          <FormItem :label="$t('Attrition_Risk')"
                            ><Tag
                              v-if="item1.exitRiskCode"
                              :color="tabColor(item1.exitRiskCode)"
                            >
                              {{ item1.exitRisk }}
                            </Tag></FormItem
                          >
                        </Col>
                        <Col span="24">
                          <FormItem :label="$t('Mobility')">
                            {{ item1.crossRegion }}</FormItem
                          ><!-- 能动性 -->
                        </Col>
                        <Col span="24">
                          <FormItem :label="$t('WHAT_Assessment_PPT')"
                            ><!-- WHAT评分 -->
                            <Select
                              v-model="item1.whatScore"
                              clearable
                              transfer
                              :disabled="selectCheck(item1)"
                              @on-change="
                                targetItemChange(item1, index, index1, num)
                              "
                              style="width: 160px"
                            >
                              <Option
                                v-for="item in Score"
                                :value="item.code"
                                :key="item.code"
                                >{{
                                  lang == "zh" ? item.ch_value : item.en_value
                                }}</Option
                              >
                            </Select>
                          </FormItem>
                        </Col>
                        <Col span="24">
                          <FormItem :label="$t('HOW_Assessment_PPT')"
                            ><!-- HOW评分 -->
                            <Select
                              v-model="item1.howScore"
                              clearable
                              transfer
                              :disabled="selectCheck(item1)"
                              @on-change="
                                targetItemChange(item1, index, index1, num)
                              "
                              style="width: 160px"
                            >
                              <Option
                                v-for="item in Score"
                                :value="item.code"
                                :key="item.code"
                                >{{
                                  lang == "zh" ? item.ch_value : item.en_value
                                }}</Option
                              >
                            </Select>
                          </FormItem>
                        </Col>
                        <Col span="24">
                          <FormItem :label="$t('Overall_Assessment_PPT')"
                            ><!-- Overall评分 -->
                            <Select
                              v-model="item1.wholeScore"
                              clearable
                              transfer
                              disabled
                              style="width: 160px"
                            >
                              <Option
                                v-for="item in Score"
                                :value="item.code"
                                :key="item.code"
                                >{{
                                  lang == "zh" ? item.ch_value : item.en_value
                                }}</Option
                              >
                            </Select>
                          </FormItem>
                        </Col>
                        <!-- 潜能评分 -->
                        <!-- <Col span="24">
                          <FormItem :label="$t('Potential_Rating')"
                            >
                            <Select
                              v-model="item1.potentialScore"
                              clearable
                              transfer
                              :disabled="selectCheck(item1)"
                              style="width: 160px"
                            >
                              <Option
                                v-for="item in PotentialScore"
                                :value="item.code"
                                :key="item.code"
                                >{{
                                  lang == "zh" ? item.ch_value : item.en_value
                                }}</Option
                              >
                            </Select>
                          </FormItem>
                        </Col> -->
                        <Col span="24">
                          <Button
                            v-if="!selectCheck(item1)"
                            @click="saveitem(item1)"
                            ><!-- 保存 -->{{ $t("Save") }}</Button
                          >
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </div>
              </Poptip>
            </div>
            <div v-else></div>
          </div>
        </Col>
      </Row>
      <Row class="patentialRow">
        <Col span="3"></Col>
        <Col
          span="4"
          v-for="(legend, lIndex) in legendRowData"
          :key="lIndex + '-legend-row'"
          >{{ legend.name }}</Col
        >
      </Row>
    </div>
    <div class="legend-box">
      <span class="legend-title">{{ $t("peopleScoreTxt") }}</span>
      <div
        class="legend-row"
        v-for="(legend, lIndex) in legendData"
        :key="lIndex + '-legend'"
      >
        <div
          class="legend-item"
          :style="{ background: getLegendBg(lIndex + 1) }"
        ></div>
        {{ legend.name }}
      </div>
      <div class="show-txt show-right">{{ $t("peopleBoardHow") }}</div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      userList: [],
      data: [],
      selsetDisabled: false,
      Score: [],
      PotentialScore: [],
      beEnd: "",
      visible: false,
      overallScoreList: [],
      bg1: "#375623",
      bg2: "#00B050",
      bg3: "#A9D08E",
      bg4: "#FFE699",
      bg5: "#d9d9d9",
    };
  },
  computed: {
    lang() {
      return this.$store.getters.selectLangeData;
    },
    legendRowData() {
      let arr = [
        {
          name: this.$t("PBScoreOne"), //需要改善
        },
        {
          name: this.$t("PBScoreTwo"), //部分达标
        },
        {
          name: this.$t("PBScoreThree"), //达到要求
        },
        {
          name: this.$t("PBScoreFour"), //超越要求
        },
        {
          name: this.$t("PBScoreFive"), //优秀出色
        },
      ];
      return arr;
    },
    legendData() {
      let arr = JSON.parse(JSON.stringify(this.legendRowData));
      return arr.reverse();
    },
  },
  methods: {
    onShowMore(item, colIndex) {
      this.$emit("onShowMore", item["scopeMap" + colIndex]);
    },
    getLegendBg(index) {
      return this["bg" + index];
    },
    getBackground(rowIndex, colIndex) {
      let bg1 = this.bg1;
      let bg2 = this.bg2;
      let bg3 = this.bg3;
      let bg4 = this.bg4;
      let bg5 = this.bg5;
      let bgColor = "";
      if (rowIndex == 0) {
        bgColor = bg1;
        if (colIndex == 1) {
          bgColor = bg4;
        }
        if (colIndex == 2) {
          bgColor = bg3;
        }
        if (colIndex == 3) {
          bgColor = bg2;
        }
      }
      if (rowIndex == 1) {
        bgColor = bg3;
        if (colIndex == 1) {
          bgColor = bg4;
        }
        if (colIndex == 4) {
          bgColor = bg2;
        }
        if (colIndex == 5) {
          bgColor = bg1;
        }
      }
      if (rowIndex == 2) {
        bgColor = bg3;
        if ([1, 2].includes(colIndex)) {
          bgColor = bg4;
        }
        if ([4, 5].includes(colIndex)) {
          bgColor = bg2;
        }
      }
      if (rowIndex == 3) {
        bgColor = bg3;
        if ([1].includes(colIndex)) {
          bgColor = bg5;
        }
        if ([2].includes(colIndex)) {
          bgColor = bg4;
        }
      }
      if (rowIndex == 4) {
        if ([1, 2].includes(colIndex)) {
          bgColor = bg5;
        }
        if ([3, 4, 5].includes(colIndex)) {
          bgColor = bg4;
        }
      }

      return bgColor;
    },
    targetItemChange(item1, index, index1, colIndex) {
      if (item1.whatScore && item1.howScore) {
        this.$set(
          this.data[index]["peopleNameList" + colIndex][index1],
          "wholeScore",
          this.getOverallScore(item1.whatScore, item1.howScore)
        );
      }
    },

    getOverallScore(whatScore, howScore) {
      let overallScore = "";
      this.overallScoreList.forEach((res) => {
        if (whatScore == res.whatScore && howScore == res.howScore) {
          overallScore = res.overallScore;
        }
      });
      return overallScore;
    },
    saveitem(item) {
      if (!this.checkScore(item)) {
        this.$Modal.confirm({
          title: `${item.userName}员工（${item.empCode}）的评分不符合规则，确认是否提交？`,
          onOk: () => {
            axios
              .post("/AchPeopleBoard/saveFifteenPeopleBoardScore", item)
              .then((res) => {
                if (res) {
                  this.$Message.success(this.$t("Save_Successful"));
                  this.$emit("saveScore");
                  item.visible = false;
                }
              });
          },
        });
      } else {
        axios
          .post("/AchPeopleBoard/saveFifteenPeopleBoardScore", item)
          .then((res) => {
            if (res) {
              this.$Message.success(this.$t("Save_Successful"));
              this.$emit("saveScore");
              item.visible = false;
            }
          });
      }
    },
    checkScore(item) {
      // let wholeScore=Number(item.wholeScore)
      // let whatScore=Number(item.whatScore)
      // let howScore=Number(item.howScore)
      // // Overall分数不大于What或How的单项分数
      // // 当What和How的分数差异大于1时，Overall的分数需在What和How的分数中间
      // if(wholeScore>whatScore&&wholeScore>howScore){
      //     console.log(111)
      //     return false
      // }else if(((whatScore-howScore)>1) && (wholeScore>=whatScore||wholeScore<=howScore)){
      //     console.log(222)
      //     return false
      // }else if(((howScore-whatScore)>1) && (wholeScore>=howScore||wholeScore<=whatScore)){
      //     return false
      // }
      return true;
    },
    tabColor(val) {
      if (val == "H") return "#C66B5F";
      else if (val == "L") return "#5AA066";
      else if (val == "M") return "#CD9153";
    },
    selectCheck(el) {
      let value = true;
      if (el.endStatus) {
        if (el.endStatus == "0" || el.beFlag == "0" || el.beCanUpdate == "1") {
          value = true;
        }
      } else if (this.beEnd) {
        if (this.beEnd == "1") {
          value = true;
        } else {
          value = false;
        }
      } else {
        el.disabledFlag == "1" ? (value = true) : (value = false);
      }
      return value;
    },
  },
};
</script>

<style lang="less" scoped>
.peo-item ,.other-item {
  height: 24px;
  padding: 3px 7px;
  font-size: 14px;
  border-radius: 3px;
}
.other-item{
  background:#2db7f5;
  }
.peo-item {
  background:#0070C0;
}
.cs-row {
  display: flex;
}
.puzzle-box {
  width: 90%;
  padding-top: 40px;
}
.legend-box {
  width: 10%;
  text-align: right;
  position: relative;
}
.show-txt {
  font-weight: bold;
  font-size: 20px;
  position: absolute;
}
.show-left {
  left: 5%;
  top: 50px;
  color: #375623;
}
.show-right {
  left: -30px;
  bottom: 40px;
  color: #16a761;
}
.legend-row {
  display: flex;
  align-items: center;
}
.legend-title {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 20px;
}
.legend-item {
  width: 30px;
  height: 28px;
  border: 1px solid #ededed;
  margin-right: 10px;
  margin-bottom: 10px;
}

.patentialRow {
  margin-top: 8px;
  display: flex;
  align-items: center;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  span {
    display: block;
    text-align: right;
    margin-right: 20px;
  }
}
.legend-title {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 20px;
}
.potentialBox {
  width: 96%;
  height: 120px;
  border: 1px solid #cccccc;
  border-radius: 10px;
  display: flex;
  flex-wrap: wrap;
  cursor: pointer;
  font-size: 22px;
  color: #fff;
  box-sizing: border-box;
  overflow-y: auto;
  padding: 5px;
  text-align: left;
}
// .potentialBox:hover {
//   opacity: 0.5;
// }

.poptipContent {
  display: flex;
  flex-direction: column;
  text-align: left;
}
::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
  background: #4ea397;
}
::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
  border-radius: 10px;
  background: #ededed;
}
/deep/.ivu-form-item {
  margin-bottom: 10px !important;
}
</style>
<style >
.popClass {
  width: 360px;
}
</style>


// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/AchAssessComponentCell2.vue